import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import styles from './ArticleHeadline.module.css';
import PropTypes from 'prop-types';

const ArticleHeadline = ({ children }) => {
  const { articleHeadline } = useSearchParamOrDefaultProps();

  return (
    <article className={styles.articleHeadlineWrapper}>
      <div className={styles.articleHeadline}>
        {children ? children : articleHeadline}
      </div>
    </article>
  );
};

ArticleHeadline.displayName = 'ArticleHeadline';

ArticleHeadline.propTypes = {
  children: PropTypes.node,
};

ArticleHeadline.defaultProps = {
  children: null,
};

export default ArticleHeadline;
